import { createSlice } from '@reduxjs/toolkit';
import { fetchApprovalCommunityData} from '../CommunityAPI/communityApi';

const fetchApprovalCommunityDataSlice = createSlice({
  name: 'fetchApprovalCommunityData',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchApprovalCommunityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovalCommunityData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApprovalCommunityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default fetchApprovalCommunityDataSlice.reducer;
